import { sort_order } from '../Common/types';

export const filterSortDefaults = {
  sort_by: 'team_name',
  sort_order: sort_order.asc,
};
